/**
 * Created by mateimisarca on 2019-06-07
 */

import CursPage from './curs-page';
export default CursPage;
